module.exports = __webpack_public_path__ + "img/banner1.7eb83361.jpg";